/* ============================================================
   Papier Royal — UX Customily (chargé partout, pas seulement FR)
   1) Fermer le customizer avec la touche ÉCHAP.
   2) Agrandir le bouton de fermeture « X » (minuscule par défaut) ×2.
   Le customizer est en DOM inline dans `.customily-modal-container`.
   ============================================================ */
(function () {
  'use strict';
  var MODAL = '.customily-modal-container';

  function modal() { return document.querySelector(MODAL); }

  function isOpen() {
    var m = modal();
    return !!(m && m.offsetWidth > 0 && m.offsetHeight > 0);
  }

  // Trouve le bouton de fermeture « X » dans le customizer.
  function findClose() {
    var m = modal();
    if (!m) return null;
    // 1) classe/id contenant "close"
    var c = m.querySelector('[class*="close" i], [id*="close" i]');
    if (c) return c;
    // 2) un élément feuille dont le texte est exactement X / ✕ / ×
    var nodes = m.querySelectorAll('button, span, div, a, i, p');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;
      var t = (el.textContent || '').trim();
      if (t === 'X' || t === 'x' || t === '✕' || t === '×' || t === '✖') return el;
    }
    return null;
  }

  // ——— ÉCHAP ferme le customizer ———
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && isOpen()) {
      var b = findClose();
      if (b) { b.click(); e.preventDefault(); e.stopPropagation(); }
    }
  }, true);

  // ——— Agrandir le « X » ×2 (dans la limite du thème) ———
  function enlarge() {
    var b = findClose();
    if (!b || b.__prBig) return;
    b.__prBig = true;
    b.style.setProperty('font-size', '2em', 'important');
    b.style.setProperty('line-height', '1', 'important');
    b.style.setProperty('padding', '0.25rem 0.5rem', 'important');
    b.style.setProperty('cursor', 'pointer', 'important');
    // si l'icône est un SVG / image
    var svg = b.querySelector('svg, img');
    if (svg) {
      svg.style.setProperty('width', '2em', 'important');
      svg.style.setProperty('height', '2em', 'important');
    }
    // titre d'accessibilité
    if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', 'Fermer');
  }

  var obs = new MutationObserver(function () { if (isOpen()) enlarge(); });
  try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  setInterval(function () { if (isOpen()) enlarge(); }, 600);
})();
